import { SVGProps } from 'react';

export const CloseXIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      {...props}
    >
      <g clipPath="url(#clip0_2680_7332)">
        <path
          d="M9.65364 7.14355L13.6337 3.1635C14.1221 2.67509 14.1221 1.88321 13.6337 1.39441L12.7491 0.509862C12.2607 0.0214524 11.4689 0.0214524 10.9801 0.509862L7 4.48992L3.01994 0.509862C2.53153 0.0214524 1.73966 0.0214524 1.25085 0.509862L0.366307 1.39441C-0.122102 1.88282 -0.122102 2.67469 0.366307 3.1635L4.34636 7.14355L0.366307 11.1236C-0.122102 11.612 -0.122102 12.4039 0.366307 12.8927L1.25085 13.7772C1.73926 14.2657 2.53153 14.2657 3.01994 13.7772L7 9.79719L10.9801 13.7772C11.4685 14.2657 12.2607 14.2657 12.7491 13.7772L13.6337 12.8927C14.1221 12.4043 14.1221 11.6124 13.6337 11.1236L9.65364 7.14355Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2680_7332">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.143555)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
